var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 64.1899C8.11655 59.7677 -2.31857 42.404 1.8 25.3038C6.23035 8.11654 23.5962 -2.31629 41 1.81013C57.8839 6.23157 68.316 23.5973 64.2 40.6962C59.7681 57.8847 42.4022 68.3156 25 64.1899Z",
    fill: "#F7931A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4574 29.0186C40.4649 32.9334 34.3385 30.9444 32.3525 30.4568L34.1049 23.5372C36.0909 24.0249 42.491 24.935 41.4574 29.0186ZM40.3687 40.1836C39.2809 44.4863 31.9215 42.1617 29.5345 41.5774L31.4683 33.9481C33.8543 34.5344 41.5055 35.6963 40.3687 40.1836ZM48.4109 29.0807C49.0495 24.8777 45.7993 22.6182 41.3541 21.1109L42.7968 15.4174L39.2769 14.5537L37.8734 20.0972C36.9481 19.8702 35.9977 19.656 35.0543 19.4437L36.4669 13.8637L32.95 13L31.5074 18.6916C30.7415 18.5198 29.9896 18.35 29.2598 18.1714L29.2638 18.1536L24.4096 16.9602L23.4732 20.6618C23.4732 20.6618 26.0848 21.2511 26.0287 21.2876C27.4552 21.6381 27.7129 22.5669 27.6698 23.3033L23.7199 38.9004C23.5454 39.3268 23.1023 39.9654 22.1068 39.7236C22.1409 39.7739 19.5484 39.0948 19.5484 39.0948L17.8 43.0629L22.3815 44.1882C23.2326 44.3985 24.0677 44.6176 24.8908 44.8249L23.4331 50.5836L26.949 51.4473L28.3916 45.7488C29.352 46.0055 30.2833 46.2424 31.1966 46.4664L29.759 52.1363L33.2789 53L34.7355 47.2531C40.7366 48.3715 45.2509 47.9204 47.1507 42.5763C48.6815 38.2736 47.0745 35.79 43.9166 34.1702C46.2164 33.647 47.9487 32.1575 48.4109 29.0807Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/BTC.9a9bd4ca2229f51e6d30413f4554920a.svg";
export { ForwardRef as ReactComponent };